<div class="border-beam-wrapper" #BorderBeamWrapper>
  <div class="border-beam" [ngStyle]="style" [ngClass]="styleClass">
    <div class="border-beam-border" [class.paused]="!isInView()"></div>
    <ng-content></ng-content>
  </div>
</div>